// extracted by mini-css-extract-plugin
export var cardHeader = "_k8-1";
export var contentCard = "_k8-0";
export var headerActions = "_k8-3";
export var reorderHandle = "_k8-5";
export var titleArea = "_k8-2";
export var titleAreaWithHandle = "_k8-4";